import React, { useEffect, useState } from "react";
import "./style.css";
import useAppAccessor from "../../../../hooks/useappAccessor";
import {
  Facebooklink,
  Messanger,
  Instagramlink,
  Link,
  Linkedinlink,
  Pinterestlink,
  Twitterlink,
  Whatsapplink,
  Star,
  NoPhoto,
  Star_Inactive,
  No_Interactions,
} from "../../../../assets/icons";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import {
  setInteractionData,
  getProductDetail,
} from "../../interaction.actions";
import _ from "lodash";
import { callEvent } from "../../../../services/main.service";
import CartSVG from "../interactionShoppingCart/components/cartSVG";
import { getBrandColor } from "../../../../utils/brand.util";
import Lottie from "react-lottie";
import animationLoaderDefault from "../../../../components/lotties/animation_loaderDefault.json";

const ZyiaUrl = "https://www.myzyia.com/";
const TranontUrl = "https://www.tranont.com/";
const PartnerCoUrl = "partner.co";

const isHost = () => {
    return window.location.href.indexOf("/stream") > -1;
};

const decimalComponent = (number: any, client: any) => {

  if (number == undefined) return;
  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    const [integerPart, decimalPart] = numb1.toString().split(".");
    const [integerPart_2, decimalPart_2] = numb2.toString().split(".");

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart ? `${integerPart}.` : `${integerPart}`}
          {decimalPart ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart}`}</span> : <span> </span>
          }
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {decimalPart_2 ? `${integerPart_2}.` : `${integerPart_2}`}
          {decimalPart_2 ? <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span> : <span> </span>
          }
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    const [integerPart_3, decimalPart_3] = number.toString().split(",");
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3},`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  } else {
    var [integerPart_3, decimalPart_3] = number.toString().split(".");
    if (decimalPart_3?.includes(" ")) {
      decimalPart_3 = decimalPart_3?.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3
            ? `${integerPart_3}.`
            : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  }
};

const decodeHtmlEntities = (html: string | undefined): string => {
  if (!html) return '';
  try {
    // 创建textarea元素来利用浏览器的HTML实体解码功能
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;

    // 如果是简单的HTML实体（如&reg;, &copy;等），textarea.value会处理
    // 但对于更复杂的HTML内容，可能需要额外的清理
    const decodedText = textarea.value;

    // 如果解码后的文本为空但原始文本不为空，则返回原始文本
    // 这可能发生在某些浏览器环境中
    return decodedText || html;
  } catch (error) {
    // 如果发生错误，返回原始文本
    console.error('Error decoding HTML entities:', error);
    return html;
  }
};

const InteractionProductList = (props: any) => {
  const dispatch = useAppDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { interactionData, productDetails, productDetail, productsInCart, productDetailsLoading } = getInteractions();
  const { referrer_user, client, user } = getUserData();
  const { joinWithAttendeeData, joinData, hostTime, createStreamData } = getLiveMainData();
  const { configurationData, infoData } = getLiveMainData();
  const [selectedItemPos, setSelectedItemPos] = useState<any>(0);
  const [interactionsAllData, setInteractionsAllData] = useState<any>([]);
  const [isShopInteraction, setIsShopInteraction] = useState(false);
  const [hasShop, setHasShop] = useState(false);
  const temparray: any = [1, 2, 3, 4, 5, 6, 10, 12];
  const [attendeList, setAtteendeList] = useState<any>([]);
  const [totalNum, setTotalNum] = useState(0);
  const { language } = getUserData();

  // 添加一个 useEffect 来监听购物车变化
  useEffect(() => {
    let total = 0;
    productsInCart.forEach((item: any) => {
      total += item.quantity;
    });
    setTotalNum(total);
  }, [productsInCart]);

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionsAllData(interactionData);
      const result = interactionData.find((obj: any) => obj.featured == true);
      // console.log("iddddd=>Resul==>", result);
      if (result?.interaction_id) {
        scrollToElement(result?.interaction_id);
      }
    } else if (interactionData.length == 0) {
      if (interactionsAllData.length > 0) {
        setInteractionsAllData(interactionData);
      }
    }
  }, [interactionData]);

  useEffect(() => {
    if (productDetail?.fromCarsoul) {
      // if (isShowCart) {
      setTimeout(() => {
        props.toDetail();
        var tmpProduct = interactionsAllData.filter((item: any) => item?.interaction_id == productDetail?.id)[0];
        handleCliclonProduct(tmpProduct);
      }, 100);
      // } else {
      //   setIsShowCart(true);
      // }
    }
  }, [productDetail])

  const extractNumberFromUrl = (url: string) => {
    const regex = /^https:\/\/(\d+)\./;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  const replaceNumberInUrl = (url: any, newNumber: any) => {
    const regex = /^(https?:\/\/)\d+(\..+)/;
    const newUrl = url.replace(regex, `$1${newNumber}$2`);
    return newUrl;
  }

  const handleCliclonProduct = (data: any) => {
  //  console.log("selected Item===>", data);

    if (isHost() !== true) {
      if(!data?.interaction_id){
        return;
      }
      var resp = joinData;
      if (referrer_user) {
        callEvent([{
          "event_data": {
            "attendee_email": resp["email"],
            "attendee_first": resp["given_name"],
            "attendee_id": resp["attendee_id"],
            "attendee_role": "attendee",
            "attendee_last": resp["family_name"],
            "client_id": infoData['hostModel']['clientId'],
            "stream_id": joinWithAttendeeData['stream_id'],
            "stream_instance_id": resp["stream_instance_id"],
            "user_id": infoData['hostModel']['userId'],
            "interaction_id": data.interaction_id,
            "interaction_type": data.attributes.type,
            "interaction_label": data.attributes.label,
            "interaction_action": data.attributes.action,
            "interaction_imageUrl": data?.style?.thumbnail_url,
            "issuer_referrer_id": referrer_user.webhook_referrer_id,
            "issuer_referrer_name": referrer_user.webhook_referrer_name,
            "elapsed_seconds": hostTime,
            "date": new Date().toUTCString()
          },
          "event_type": "interaction_clicked"
        }]);
      } else {
        callEvent([{
          "event_data": {
            "attendee_email": resp["email"],
            "attendee_first": resp["given_name"],
            "attendee_id": resp["attendee_id"],
            "attendee_role": "attendee",
            "attendee_last": resp["family_name"],
            "client_id": infoData['hostModel']['clientId'],
            "stream_id": joinWithAttendeeData['stream_id'],
            "stream_instance_id": resp["stream_instance_id"],
            "user_id": infoData['hostModel']['userId'],
            "interaction_id": data.interaction_id,
            "interaction_type": data.attributes.type,
            "interaction_label": data.attributes.label,
            "interaction_action": data.attributes.action,
            "interaction_imageUrl": data?.style?.thumbnail_url,
            "elapsed_seconds": hostTime,
            "date": new Date().toUTCString()
          },
          "event_type": "interaction_clicked"
        }]);
      }
    }

    if (isHost() === true) {
      let tempArray: any = [];
      tempArray = _.cloneDeep(interactionsAllData);
      setInteractionsAllData([]);
      tempArray.forEach((element: any) => {
        if (element.interaction_id === data.interaction_id) {
          element.featured = !element.featured;
          callEvent([{
            "event_data": {
              "stream_id": createStreamData['stream_id'],
              "stream_instance_id": createStreamData["stream_instance_id"],
              "interaction_id": data.interaction_id,
              "elapsed_seconds": hostTime,
              "date": new Date().toUTCString()
            },
            "event_type": "feautred_interaction"
          }]);
        } else {
          element.featured = false;
        }
      });
      setInteractionsAllData(tempArray);
    } else if (data?.real_type === "shop_com") {
      // console.log(productDetails, "productDetails");
      // console.log(data, "data");
      var tmpProduct = productDetails.filter((item: any) => item?.id == data?.interaction_id)[0];
      if(tmpProduct){
        tmpProduct['fromCarsoul'] = false;
        dispatch(getProductDetail(tmpProduct));
        props.toggleProductList(true);
      }
    } else if (data?.attributes?.siteName === "tranont" || data?.attributes?.siteName === "Trannont") {
      var tmpProduct = productDetails.filter((item:any)=>item?.opContainerId==data?.interaction_id)[0];
      // tmpProduct['fromCarsoul'] = false;
      dispatch(getProductDetail(tmpProduct));
      props.toggleProductList(true);
    } else if (data?.attributes?.siteName?.toLowerCase().trim() === "partner.co") {
      var tmpProduct = productDetails.filter((item:any)=>item?.opContainerId==data?.interaction_id)[0];
      // tmpProduct['fromCarsoul'] = false;
      dispatch(getProductDetail(tmpProduct));
      props.toggleProductList(true);
    } else if (data?.interaction_type !== "media") {
      openLinkNewTab(data?.attributes?.action);
    } else if (extractBaseUrl(data?.attributes?.action) === ZyiaUrl) {
      if (
        data?.interaction_subtype === "facebook" ||
        data?.interaction_subtype === "linkedin" ||
        data?.interaction_subtype === "twitter" ||
        data?.interaction_subtype === "instagram"
      ) {
        meidaAttributionShopifyClick(
          data?.attributes?.action,
          data?.attributes?.label,
          data?.interaction_id,
          joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
          referrer_user?.shop_site_name
            ? referrer_user.shop_site_name
            : joinWithAttendeeData?.issuer_metadata?.shop_site_name,
          referrer_user?.shop_site_name
        );
      } else {
        shopifyAttributionClick(
          data?.attributes?.action,
          data?.attributes?.label,
          data?.attributes.assetId,
          joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
          joinWithAttendeeData?.issuer_metadata?.shop_site_name,
          referrer_user?.shop_site_name
        );
      }
    } else if (extractBaseUrl(data?.attributes?.action) === TranontUrl) {
      attachReferer(
        data?.attributes?.action,
        referrer_user?.third_party_username
          ? referrer_user?.third_party_username
          : joinWithAttendeeData?.issuer_metadata?.third_party_username,
      )
    } else if (extractBaseUrl(data?.attributes?.action).includes(PartnerCoUrl)) {
      try {
        const url = new URL(data?.attributes?.action);
        const pathSegments = url.pathname.split("/").filter(Boolean);
        
        const thirdPartyUsername = referrer_user?.third_party_username || 
          joinWithAttendeeData?.issuer_metadata?.third_party_username;
        
        if (thirdPartyUsername && pathSegments.length > 0) {
          pathSegments[pathSegments.length - 1] = thirdPartyUsername;
          url.pathname = "/" + pathSegments.join("/");
        }
        
        const newUrl = url.toString();
        openLinkNewTab(newUrl);
      } catch (error) {
        openLinkNewTab(data?.attributes?.action);
      }
    }
    else if (
      data?.interaction_subtype === "facebook" ||
      data?.interaction_subtype === "linkedin" ||
      data?.interaction_subtype === "twitter" ||
      data?.interaction_subtype === "instagram"
    ) {
      meidaAttributionClick(
        data?.attributes?.action,
        data?.attributes?.label,
        data?.interaction_id,
        joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
        referrer_user?.third_party_username
          ? referrer_user?.third_party_username
          : joinWithAttendeeData?.issuer_metadata?.third_party_username
      );
    } else {
      attachUtm(
        data?.attributes?.action,
        joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
        referrer_user?.third_party_username
          ? referrer_user?.third_party_username
          : joinWithAttendeeData?.issuer_metadata?.third_party_username,
        data
      );

      // openInNewTab(
      //   data?.attributes?.action,
      //   data?.attributes?.label,
      //   data?.attributes.assetId,
      // joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
      // referrer_user?.third_party_username
      //   ? referrer_user?.third_party_username
      //   : joinWithAttendeeData?.issuer_metadata?.third_party_username,
      //   joinWithAttendeeData?.issuer_metadata?.third_party_username
      // );

      // props.iframeURL(data?.attributes?.action)
      // props.showIframe(true)

      // dispatch(setSelectedInteractionData(data))
      // props.iframeURL(data.data?.attributes?.action)
      // props.showIframe(true)
    }
  };
  useEffect(() => {
    if (interactionsAllData.length > 0) {
      dispatch(setInteractionData(interactionsAllData));
    }
    hasShopCom();
  }, [interactionsAllData]);

  useEffect(() => {
    setAtteendeList(joinWithAttendeeData.attendees);
  }, [joinWithAttendeeData]);
  function extractBaseUrl(url: any) {
    const urlObject = new URL(url);

    const baseUrl = `${urlObject.protocol}//${urlObject.hostname}/`;

    return baseUrl;
  }

  function extractPathAndQuery(url: any) {
    const urlObject = new URL(url);
    const pathAndQuery =
      urlObject.pathname +
      urlObject.search.replace("publisherID=AP1701813", "");
    return pathAndQuery;
  }

  function extractPathAndQueryShopify(url: any) {
    const urlObject = new URL(url);
    const pathAndQuery =
      urlObject.pathname +
      urlObject.search.replace("publisherID=AP1701813", "");
    const newPathAndQuery = pathAndQuery.replace("/CORPORATE", "");
    return newPathAndQuery;
  }

  function extractPathAndQueryMediaShopCom(url: any) {
    const urlObject = new URL(url);
    const pathAndQuery =
      urlObject?.pathname +
      urlObject?.search?.replace("publisherID=AP1701813", "");
    if (referrer_user && referrer_user?.media_interaction_replacement_url) {
      const urlObjectReferenced = new URL(referrer_user?.media_interaction_replacement_url);
      const index = urlObjectReferenced.pathname.indexOf("/admin")
      const pathAndQueryUserName = urlObjectReferenced.pathname.slice(0, index).replace("/", "");
      const indexOther = pathAndQuery.indexOf("?credituser")
      const pathAndQueryUserNameOther = pathAndQuery.slice(0, indexOther);
      const format = pathAndQueryUserNameOther.replace("/testportalusaqashp", "");

      if (urlObject.hostname.includes("shop.com")) {
        const result = `${format}?credituser=${pathAndQueryUserName}`;
        return result;
      } else {
        return format.replace("idType=produc", "idType=product");
      }
    }
    if (!referrer_user || !referrer_user?.media_interaction_replacement_url) {
      const newPathAndQuery = pathAndQuery.replace(
        "/testportalusaqashp",
        ""
      );
      return newPathAndQuery;
    }
  }

  function extractPathAndQueryMediaMA(url: any) {
    const urlObject = new URL(url);
    if (referrer_user && referrer_user?.media_interaction_replacement_url) {
      const urlObjectReferenced = new URL(referrer_user?.media_interaction_replacement_url);
      const index = urlObjectReferenced.pathname.indexOf("/admin")
      const pathAndQueryUserName = urlObjectReferenced.pathname.slice(0, index);
      const indexOther = urlObject.pathname.indexOf("/file")
      const pathAndQueryUserNameOther = urlObject.pathname.slice(indexOther);
      const result = `${pathAndQueryUserName}${pathAndQueryUserNameOther}`;
      return result.replace("/asset_redirec", "");
    }
    if (!referrer_user || !referrer_user?.media_interaction_replacement_url) {
      return urlObject?.pathname;
    }
  }

  function extractMarketamer(inputString: any) {
    const separatorIndex = inputString.indexOf("|");
    const marketamerPart = inputString.substring(separatorIndex + 1);
    const marketamer = marketamerPart.split("-")[0];

    return marketamer;
  }

  const attachReferer = (
    url: string,
    thirdPartyUsername: string,
  ): string => {
    let link = url;

    if (!/^https?:\/\//i.test(url)) {
      link = `https://${url}`;
    }

    const finalUrl = new URL(link);

    finalUrl.searchParams.set('share', thirdPartyUsername);

    // console.log(finalUrl.href);
    var newLink = finalUrl.href;
    const newWindow = window.open(newLink, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;

    return "";
  }

  const attachUtm = (
    url: string,
    clientId: string,
    thirdPartyUsername: string,
    interaction: any,
  ): string => {
    let link = url;

    if (!/^https?:\/\//i.test(url)) {
      link = `https://${url}`;
    }
    const finalUrl = new URL(link);

    let utmSource = 'verbLive';
    let utmMedium = 'verbLive';
    let campaign = '';

    campaign = extractMarketamer(clientId);


    let utmTerm = '';
    if (interaction?.attributes.label) {
      utmTerm = interaction.attributes.label
        .replace(/ /g, '_')
        .replace(/[^a-zA-Z0-9_]/g, '');
    }

    const utmContent = interaction?.attributes.assetId || interaction?.interactionId;

    const utmDistributor = thirdPartyUsername || '';

    // console.log(referrer_user, "referrer_user");

    finalUrl.searchParams.set('utm_source', utmSource);
    finalUrl.searchParams.set('utm_medium', utmMedium);
    finalUrl.searchParams.set('utm_campaign', campaign);
    finalUrl.searchParams.set('utm_term', utmTerm || '');
    finalUrl.searchParams.set('utm_distributor', utmDistributor);
    finalUrl.searchParams.set('utm_content', utmContent || '');

    const MAShopHosts = [
      'www.shop.com',
      'www.isotonix.com',
      'www.tlsslim.com',
      'www.nutrametrix.com',
      'www.motivescosmetics.com',
      'www.lumieredevie.com',
      'www.getlayered.com',
      'mys.shop.com',
    ];
    var isMA = false;
    if (MAShopHosts.includes(finalUrl.host)) {
      // Hard-coded sourceid for marketamerica
      finalUrl.searchParams.set('sourceid', '4444');
      isMA = true;
    }

    var newLink = finalUrl.href;
    if (isMA) {
      // console.log(newLink, '++linke1');
      if (referrer_user?.media_interaction_replacement_url) {
        var userId = extractNumberFromUrl(referrer_user?.media_interaction_replacement_url);
       if (joinWithAttendeeData && joinWithAttendeeData.issuer_metadata && joinWithAttendeeData.issuer_metadata.third_party_username)
        newLink = newLink.replace('/'+joinWithAttendeeData.issuer_metadata.third_party_username,'');
        if (extractBaseUrl(newLink).includes("shop.com")) {
          // console.log(userId);
          finalUrl.searchParams.set('credituser', 'R'+userId);
          // console.log(extractPathAndQuery(newLink));
          var link1 = replaceNumberInUrl(extractBaseUrl(newLink),userId) +
          referrer_user?.third_party_username +
          extractPathAndQuery(newLink);
          
          link1 = link1.replace(/([?&])credituser=R?\d+/, `$1credituser=R${userId}`);
          // console.log('link11111111111111', link1);
          const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
          if (newWindow) newWindow.opener = null;
          return "";
        }
        else if (extractBaseUrl(newLink).includes("motivescosmetics.com")) {
          const urlObject = new URL(url);
          const urlObjectReferenced = new URL(referrer_user?.media_interaction_replacement_url);
          const newBaseUrl = `${urlObject.protocol}//${urlObjectReferenced.hostname}`;
          var link1 = "";
          if (interaction.attributes.isMAShop === true) {
            link1 = replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
              referrer_user?.third_party_username +
              extractPathAndQuery(finalUrl.href);
          } else {
            link1 = replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
              extractPathAndQuery(finalUrl.href);
          }
          // console.log(finalUrl.href, '++linke1');
          // console.log(link1, '++linke1');
          link1 = link1.replace("/testportalusaqashp", "/" + referrer_user?.third_party_username);
          // console.log(replaceNumberInUrl(extractBaseUrl(finalUrl.href),userId));
          // console.log(link1, '++linke1');
          const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
          if (newWindow) newWindow.opener = null;
        } else {
          const urlObject = new URL(url);
          const urlObjectReferenced = new URL(referrer_user?.media_interaction_replacement_url);
          const newBaseUrl = `${urlObject.protocol}//${urlObjectReferenced.hostname}`;
          var link1 = replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
            referrer_user?.third_party_username +
            extractPathAndQuery(finalUrl.href);
          // console.log(finalUrl.href, '++linke1');
          // console.log(link1, '++linke1');
          link1 = link1.replace("/testportalusaqashp", "/" + referrer_user?.third_party_username);
          // console.log(replaceNumberInUrl(extractBaseUrl(finalUrl.href),userId));
          // console.log(link1, '++linke1');
          const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
          if (newWindow) newWindow.opener = null;
        }
      } else {
    // console.log(newLink, '++linke1');
      var link1 = extractBaseUrl(newLink) +
     (newLink.lastIndexOf(`${utmDistributor}`) > 0 ? '' : `${utmDistributor}`)  +
      extractPathAndQuery(newLink);
      link1 = link1.replace("/testportalusaqashp/testportalusaqashp", "/testportalusaqashp");
     
      const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
      }
    } else if (finalUrl.href.includes("myarieyl") || finalUrl.href.includes("eexcelusa")) {
      openLinkNewTab(replaceHost(finalUrl.href, referrer_user.media_interaction_replacement_url));
    } else {
      if (referrer_user?.media_interaction_replacement_url) {
        var userId = extractNumberFromUrl(referrer_user?.media_interaction_replacement_url);
        // console.log(userId, '++userId');
        var link1 = replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
          extractPathAndQuery(finalUrl.href).substring(1);
        // console.log(link1, '++linke1');
        const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
      } else {
        const newWindow = window.open(newLink, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
      }
    }

    return "";
  }

  const replaceHost = (url1: string, url2: string) => {
    if (url2) {
      const originalUrl = new URL(url1);
      const newHostUrl = new URL(url2);

      originalUrl.host = newHostUrl.host;

      return originalUrl.toString();
    } else {
      return url1;
    }
  }


  const openInNewTab = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    utm_distributor: string
  ): void => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");

    var newURL = '';
    // console.log("thirdPartyUsername", thirdPartyUsername);
    // console.log(clientId);
    // console.log(utm_distributor);
    // console.log(extractPathAndQuery(url));
    newURL = extractBaseUrl(url) +
      `${thirdPartyUsername}` +
      extractPathAndQuery(url) +
      (extractBaseUrl(url).includes("shop.com")
        ? `utm_source=${"verbLive"}`
        : `&utm_source=${"verbLive"}`) +
      `&utm_campaign=${extractMarketamer(clientId)}` +
      `&utm_term=${utmTerm}` +
      `&utm_distributor=${utm_distributor}` +
      `&utm_content=${assetId}` +
      `&sourceid=4444`;
    // console.log(newURL);

    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const openLinkNewTab = (dataLink: any) => {
    if (!dataLink.match(/^https?:\/\//i)) {
      dataLink = "http://" + dataLink;
    }

    const newURL = dataLink;

    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");

    if (newWindow) newWindow.opener = null;
  };

  const meidaAttributionShopifyClick = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    shopsitename: string
  ) => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");
    // console.log("third_party_username", thirdPartyUsername);
    if (!shopsitename) {
      const newURL =
        extractBaseUrlShopify(url) +
        `${(extractBaseUrlShopify(url).includes("crm.verb") || extractBaseUrlShopify(url).includes("sharezyia"))
          ? `/${thirdPartyUsername}` + extractPathAndQueryMedia(url) + `?utm_source=${"verbLive"}`
          : extractPathAndQueryMediaShopCom(url) + `&utm_source=${"verbLive"}`
        }` +
        `&utm_medium=${"verbLive"}` +
        `&utm_campaign=${extractMarketamer(clientId)}` +
        `&utm_term=${utmTerm}` +
        `&utm_distributor=${""}` +
        `&utm_content=${assetId}`;
      const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    } else {
      const newURL =
        extractBaseUrlShopify(url) +
        `${(extractBaseUrlShopify(url).includes("crm.verb") || extractBaseUrlShopify(url).includes("sharezyia"))
          ? `/${shopsitename}` + extractPathAndQueryMedia(url) + `?utm_source=${"verbLive"}`
          : `/${shopsitename ? shopsitename : ""}` +
          extractPathAndQueryMediaShopify(url) + `&utm_source=${"verbLive"}`
        }` +
        `&utm_medium=${"verbLive"}` +
        `&utm_campaign=${extractMarketamer(clientId)}` +
        `&utm_term=${utmTerm}` +
        `&utm_distributor=${""}` +
        `&utm_content=${assetId}`;
      const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  function extractPathAndQueryMedia(url: any) {
    const urlObject = new URL(url);
    const index = urlObject.pathname.indexOf("/file");
    const pathAndQuery = urlObject.pathname.slice(index);
    return pathAndQuery;
  }

  function extractPathAndQueryMediaShopify(url: any) {
    const urlObject = new URL(url);
    const index = urlObject.href.indexOf("/shop");
    const pathAndQuery = urlObject.href.slice(index);
    return pathAndQuery.replace("page=0&", "");
  }

  const getIconManualInteraction = (type: any) => {
    switch (type) {
      case "Facebook":
        return Facebooklink;
      case "Instagram":
        return Instagramlink;
      case "LinkedIn":
        return Linkedinlink;
      case "Twitter":
        return Twitterlink;
      case "Pinterest":
        return Pinterestlink;
      case "Messenger":
        return Messanger;
      case "WhatsApp":
        return Whatsapplink;
      default:
        return NoPhoto;
    }
  };

  const shopifyAttributionClick = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    shopsitename: string
  ) => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");
    const newURL =
      extractBaseUrlShopifyWithSiteName(
        url,
        shopsitename ? shopsitename : thirdPartyUsername
      ) +
      extractPathAndQueryShopify(url) +
      `&utm_source=${"verbLive"}` +
      `&utm_medium=${"verbLive"}` +
      `&utm_campaign=${extractMarketamer(clientId)}` +
      `&utm_term=${utmTerm}` +
      `&utm_distributor=${""}` +
      `&utm_content=${convertSpecialCharacters(assetId)}`;

    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const meidaAttributionClick = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string
  ) => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");
    const newURL =
      extractBaseUrlShopify(url) +
      `${(extractBaseUrlShopify(url).includes("crm.verb") || extractBaseUrlShopify(url).includes("unfranchisemarketing") || extractBaseUrlShopify(url).includes("sharezyia"))
        ? extractPathAndQueryMediaMA(url) + `?utm_source=${"verbLive"}`
        : `/${thirdPartyUsername}` + extractPathAndQueryMediaShopCom(url) + `&utm_source=${"verbLive"}`
      }` +

      `&utm_medium=${"verbLive"}` +
      `&utm_campaign=${extractMarketamer(clientId)}` +
      `&utm_term=${utmTerm}` +
      `&utm_distributor=${""}` +
      `&utm_content=${assetId}`;
    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  function extractBaseUrlShopify(url: any) {
    const urlObject = new URL(url);
    const baseUrl = `${urlObject.protocol}//${urlObject.hostname}`;
    if ((urlObject.hostname.includes("unfranchisemarketing") || urlObject.hostname.includes("sharezyia")) && referrer_user?.media_interaction_replacement_url) {
      const urlObjectReferenced = new URL(referrer_user?.media_interaction_replacement_url);
      const newBaseUrl = `${urlObject.protocol}//${urlObjectReferenced.hostname}`;
      return newBaseUrl
    }
    return baseUrl;
  }

  function extractBaseUrlShopifyWithSiteName(url: any, shopsitename: any) {
    const urlObject = new URL(url);
    const baseUrl = `${urlObject.protocol}//${urlObject.hostname}/${shopsitename}`;
    return baseUrl;
  }

  function convertSpecialCharacters(url: any) {
    const convertedUrl = encodeURIComponent(url);
    return convertedUrl;
  }

  const getInteractionTypeCheck = (type: any) => {
    switch (type) {
      case "social":
        return false;
      case "link":
        return false;
      case "media":
        return true;
      default:
        return true;
    }
  };

  const getLinkValidation = (type: any, url: any) => {
    if (type == "link") {
      if (url == "") {
        return false;
      } else {
        return true;
      }
    }
  };

  const showObject = (data: any) => {
    if (isHost()) {
      return true;
    } else {
      if (data?.attributes?.shouldShow) {
        return true;
      } else {
        return false;
      }
    }
  };

  const hasShopCom = () => {
    var flag = false;
    interactionsAllData.map((data: any, index: any) => {
      if (data?.attributes?.shouldShow && data?.real_type === "shop_com") {
        flag = true;
      }
    });
    setHasShop(flag);
  }

  const scrollToElement = (id: any) => {
    const targetElement = document.getElementById("main_" + id);

    if (targetElement) {
      // console.log("Target Element:", targetElement);

      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    } else {
      // console.log(`Element with ID ${id} not found.`);
    }
  };


  const checkTitle = (title: string) => {

    const formattedStringFirst = title.replace(/#\d+\b\.?\s?/g, '');
    const formattedString = formattedStringFirst.replace(/[^\x20-\x7E®]/g, '');

    if (formattedString.includes('Lumire')) {
      return formattedString.replace('Lumire', "Lumière")
    }

    return formattedString.trim();
  }

  // Create a local loading component using the same animation as the global loader
  const LocalLoadingIndicator = () => {
    if (!productDetailsLoading) return null;
    
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationLoaderDefault,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    
    return (
      <div className="flex justify-center items-center py-8">
        <div className="flex flex-col items-center">
          <Lottie options={defaultOptions} height={60} width={60} speed={3} />
          <p className="text-gray-600 text-sm mt-2">Loading product details...</p>
        </div>
      </div>
    );
  };

  return (
    <>
      {productDetailsLoading ? (
        <LocalLoadingIndicator />
      ) : (
        <>
          {window.location.href.indexOf('/stream') === -1 && interactionsAllData.filter((data: any, index: any) => showObject(data)).length > 0 && <div>
            <div className="h-16 w-full flex justify-between items-center bg-white border-b border-gray-200 shadow-sm"
              style={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.95)",
              }}
            >
              <div className="ml-4 w-10 h-10 flex items-center justify-center" style={{ width: "40px" }}></div>
              <div className="flex-grow text-center">
                <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
                  {language['shop_label']}
                </h1>
              </div>
              {window.location.href.indexOf('/stream') === -1 &&
                <button
                  className="mr-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 relative group"
                  onClick={() => { props.toCart() }}
                  aria-label="View cart"
                >
                  {client.toLowerCase() === 'partner.co' ? (
                   null
                  ) : (
                    <div className="group-hover:opacity-80 transition-opacity">
                      <CartSVG width="22px" stroke={getBrandColor(client)}></CartSVG>
                    </div>
                  )}
                  {totalNum > 0 && (
                    <div
                      className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 flex items-center justify-center bg-gradient-to-r from-red-500 to-red-600 text-white text-xs font-bold rounded-full shadow-lg border-2 border-white"
                      style={{
                        boxShadow: "0 2px 8px rgba(239, 68, 68, 0.4)",
                      }}
                    >
                      {totalNum > 99 ? "99+" : totalNum}
                    </div>
                  )}
                </button>
              }
            </div>
          </div>}
          {
            interactionsAllData.filter((data: any, index: any) => showObject(data)).length == 0 && <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '200px',
              }}
            >
              <>
                <img src={No_Interactions} className="mx-auto mt-10" style={{ height: 74, width: 74 }}></img>
                <div style={{ width: '269px', textAlign: 'center', marginTop: '10px' }}>
                  <p style={{ color: '#DEDEDE', fontSize: '16px', fontWeight: '400', lineHeight: '28px' }}>{language['no_interactions']}.</p>
                </div>
              </>
            </div>
          }
          {interactionsAllData.map((data: any, index: any) => {
            return (
              <>
                {showObject(data) && (
                  <div
                    className={`${data?.featured ? `bg-${getBrandColor(client)}` : "bg-white"}`}
                  >
                    <div
                      id="interactonRow"
                      className={`flex  w-full items-center pl-3  cursor-pointer relative ${data?.attributes?.shouldShow ? "opacity-100" : "opacity-50"
                        }`}
                      style={{ backgroundColor: data?.featured ? `${getBrandColor(client)} ` : "white" }}
                      onClick={() => {
                        if (isHost()) {
                          handleCliclonProduct(data);
                        } else {
                          if (data?.real_type?.toLowerCase() === 'shop_com' || data?.real_type?.toLowerCase() === 'tranont' || data?.real_type?.toLowerCase() === 'partner.co') {
                            props.toDetail();
                          }
                          handleCliclonProduct(data);
                        }
                      }}
                    >
                      {data?.featured && (
                        <div className="flex absolute right-2 top-2 border border-white rounded pl-1.5 pr-1.5 pt-1 pb-1">
                          <span
                            className={`text-sm ${data?.featured ? "text-white" : "text-[#936FFF]"
                              }  mb-0 mr-2`}
                          >
                            {language["featured"]}
                          </span>
                          {/* {data?.featured&&<BsStarFill size={15} color={(data?.featured)?'#ffffff':'#936FFF'}></BsStarFill>} */}
                          {data?.featured && (
                            <img
                              src={Star}
                              style={{
                                height: "21px !important",
                                width: "21px !important",
                              }}
                            ></img>
                          )}
                        </div>
                      )}

                      {!data?.featured && (
                        <div className="flex opacity-20 absolute right-2 top-2 border border-black rounded pl-1.5 pr-1.5 pt-1 pb-1">
                          <span
                            className={`text-sm ${data?.featured ? "text-white" : "text-black"
                              }  mb-0 mr-2`}
                          >
                            {language["featured"]}
                          </span>
                          {/* {data?.featured&&<BsStarFill size={15} color={(data?.featured)?'#ffffff':'#936FFF'}></BsStarFill>} */}
                          {!data?.featured && (
                            <img
                              src={Star_Inactive}
                              style={{
                                height: "21px !important",
                                width: "21px !important",
                              }}
                            ></img>
                          )}
                        </div>
                      )}

                      <div
                        className="flex items-center justify-center mb-3 mt-2"
                        id={"main_" + data?.interaction_id}
                        style={{ marginTop: data?.featured ? 18 : 18 }}
                      >
                        <div
                          className={` flex  items-center justify-center ${getInteractionTypeCheck(data?.interaction_type)
                              ? "bg-white"
                              : ""
                            } h-[75px] min-h-[75px] min-w-[75px] w-[75px] ${getInteractionTypeCheck(data?.interaction_type)
                              ? "rounded-lg border border-[#979797]"
                              : ""
                            } mt-2 relative`}
                        >
                          {/* <img src={'https://www.kasandbox.org/programming-images/avatars/marcimus-orange.png'} alt="Icon" height={68} width={68}  /> */}
                          {data?.interaction_type == "link" ? (
                            <img
                              src={
                                getLinkValidation(
                                  data?.interaction_type,
                                  data?.style?.thumbnail_url
                                )
                                  ? data?.style?.thumbnail_url
                                  : NoPhoto
                              }
                              alt="Icon"
                              style={
                                getLinkValidation(
                                  data?.interaction_type,
                                  data?.style?.thumbnail_url
                                )
                                  ? { height: 68, width: 68 }
                                  : { height: 28, width: 28 }
                              }
                              className={`${data?.attributes?.shouldShow
                                  ? "opacity-100 "
                                  : "opacity-50"
                                }`}
                            />
                          ) : (
                            <img
                              src={
                                getInteractionTypeCheck(data?.interaction_type)
                                  ? data?.style?.thumbnail_url
                                  : getIconManualInteraction(data?.interaction_icon)
                              }
                              alt="Icon"
                              style={{ height: 68, width: 68 }}
                              className={`${data?.attributes?.shouldShow
                                  ? "opacity-100 "
                                  : "opacity-50"
                                }`}
                            />
                          )}
                          {/* {!data?.interaction_id.includes("pdf") &&
                            !data?.interaction_type.includes("social") &&
                            !data?.interaction_type.includes("link") &&
                            !data?.interaction_id.includes("link") && (
                              <div
                                className={` flex  w-full rounded-b-lg bg-hussle_light_blue_2 text-black justify-center absolute bottom-0  ${
                                  data?.attributes?.shouldShow
                                    ? "opacity-100 "
                                    : "opacity-50"
                                }`}
                              >
                                Buy
                              </div>
                            )} */}
                        </div>
                        <div className="ml-2 flex-col flex items-start pt-3 min-w-0 flex-1">
                          {data?.attributes?.labelVisible && (
                            <span
                              className={`${data?.featured ? "text-white" : "text-[#595959]"
                                } font-medium mb-0 ${data?.attributes?.shouldShow
                                  ? "opacity-100 "
                                  : "opacity-50"
                                }`}
                              style={{
                                fontSize: '1rem',
                                lineHeight: '1.5rem',
                                width:
                                  document.getElementById("interactonRow")
                                    ?.offsetWidth != null
                                    ? document.getElementById("interactonRow")!
                                        .offsetWidth - 130
                                    : "100%",
                                maxWidth: "100%",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                wordBreak: "break-word",
                              }}
                              title={decodeHtmlEntities(data?.attributes?.label)}
                            >
                              {decodeHtmlEntities(data?.attributes?.label)}
                            </span>
                          )}
                          {/* {data?.interaction_type=='shop_com'&&<span className={`text-lg	 text-[#595959] font-medium border border-[#979797] rounded-md pl-1 pr-1   ${(data?.featured)?'bg-white':''}`} >{data?.attributes?.price}</span>} */}
                          {!data?.interaction_id.includes("pdf") &&
                            !data?.interaction_type.includes("social") &&
                            !data?.interaction_type.includes("link") &&
                            !data?.interaction_id.includes("link") && (
                              <span
                                className={`text-lg	 text-[#595959] font-medium border border-[#979797] rounded-md pl-1 pr-1   ${data?.featured ? "bg-white" : ""
                                  }  ${data?.attributes?.shouldShow
                                    ? "opacity-100 "
                                    : "opacity-50"
                                  }`}
                              >
                                {decimalComponent(
                                  data?.attributes?.price,
                                  configurationData?.company_name
                                )}
                              </span>
                            )}

                          {/* {data?.interaction_id.includes("pdf") ||
                            ((data?.interaction_type.includes("link") ||
                              data?.interaction_type.includes("social")) && (
                              <span
                                className={`text-base ${
                                  data?.featured ? "text-white" : "text-[#595959]"
                                } font-medium mb-0  ${
                                  data?.attributes?.shouldShow
                                    ? "opacity-100 "
                                    : "opacity-50"
                                }`}
                                style={{
                                  width:
                                    document.getElementById("interactonRow")
                                      ?.offsetWidth! - 130,
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                }}
                              >
                                {data?.attributes?.action.replace(
                                  /(^\w+:|^)\/\//,
                                  ""
                                )}
                              </span>
                            ))} */}
                          {/* {data?.interaction_id.includes("link") && (
                            <span
                              className={`text-base ${
                                data?.featured ? "text-white" : "text-[#595959]"
                              } font-medium mb-0  ${
                                data?.attributes?.shouldShow
                                  ? "opacity-100 "
                                  : "opacity-50"
                              }`}
                              style={{
                                width:
                                  document.getElementById("interactonRow")
                                    ?.offsetWidth! - 130,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {data?.attributes?.action.replace(
                                /(^\w+:|^)\/\//,
                                ""
                              )}
                            </span>
                          )} */}
                        </div>
                      </div>
                    </div>
                    <div className="border-t-2 ml-2 mr-2 "></div>
                  </div>
                )}
              </>
            );
          })}
        </>
      )}
    </>
  );
};

export default InteractionProductList;
